import type { LucideIcon } from 'lucide-react';

/** Lucide at stroke width 1.75, sizes 20 or 24 (DESIGN_SYSTEM §2.4). Decorative: the control carries the label. */
export function Icon({ icon: Glyph, size = 24, className }: { icon: LucideIcon; size?: 20 | 24; className?: string }) {
  return <Glyph size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" className={className} />;
}
